<template>
  <ul class="tw-grid md:tw-grid-cols-2 tw-gap-5">
    <li class="tw-h-10 tw-relative">
      <input type="text" :value="search" @input="(event) => $emit('search', event.target.value)" @focus="setCitiesVisible(false)" class="tw-border tw-appearance-none tw-border-solid tw-border-[#DCDCDC] tw-border-t-[#DCDCDC] tw-w-full tw-h-full tw-px-4 2xl:tw-px-6 tw-text-[12px] 2xl:tw-text-[1rem] placeholder:tw-text-[#DCDCDC]" placeholder="Search">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-absolute tw-right-[16px] tw-top-[12px]">
        <path d="M11.4286 10.0571H10.6971L10.4229 9.78286C11.3691 8.72812 11.8903 7.35983 11.8857 5.94286C11.8857 4.76748 11.5372 3.61849 10.8842 2.64119C10.2312 1.66389 9.30301 0.902177 8.21709 0.452376C7.13118 0.0025756 5.93627 -0.115114 4.78347 0.114193C3.63066 0.343499 2.57175 0.909503 1.74063 1.74063C0.909503 2.57175 0.343499 3.63066 0.114193 4.78347C-0.115114 5.93627 0.0025756 7.13118 0.452376 8.21709C0.902177 9.30301 1.66389 10.2312 2.64118 10.8842C3.61848 11.5372 4.76748 11.8857 5.94286 11.8857C7.35983 11.8903 8.72812 11.3691 9.78286 10.4229L10.0571 10.6971V11.4286L14.6286 16L16 14.6286L11.4286 10.0571ZM5.94286 10.0571C5.12913 10.0571 4.33368 9.81585 3.65708 9.36376C2.98049 8.91168 2.45316 8.26912 2.14176 7.51733C1.83036 6.76554 1.74888 5.9383 1.90763 5.1402C2.06638 4.34211 2.45823 3.60902 3.03362 3.03362C3.60901 2.45823 4.34211 2.06638 5.1402 1.90763C5.9383 1.74888 6.76554 1.83036 7.51733 2.14176C8.26911 2.45316 8.91168 2.98049 9.36376 3.65708C9.81585 4.33367 10.0571 5.12913 10.0571 5.94286C10.0594 6.4838 9.9546 7.01984 9.74865 7.52004C9.5427 8.02025 9.23973 8.47472 8.85722 8.85722C8.47472 9.23973 8.02025 9.5427 7.52004 9.74865C7.01984 9.95459 6.4838 10.0594 5.94286 10.0571Z" fill="#272727"/>
      </svg>
    </li>
    <li class="tw-h-10">
      <ul class="tw-grid tw-grid-cols-2 tw-gap-5 tw-h-full">
        <li id="cities-list" class="tw-relative">
          <button @click="setCitiesVisible(!citiesVisible)" class="tw-border tw-border-solid tw-border-[#DCDCDC] tw-w-full tw-flex tw-justify-between tw-h-full tw-items-center tw-px-4 2xl:tw-px-6 tw-bg-white tw-cursor-pointer">
            <span class="tw-text-[#DCDCDC] tw-text-[12px] 2xl:tw-text-[1rem]">{{ currentCity ? cities.find(el => el.id === currentCity).city : 'Country' }}</span>
            <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-rotate-0 tw-transition-all" :class="{'tw-rotate-180' : citiesVisible}">
              <path d="M1 1L7 7L13 1" stroke="black" stroke-width="2"/>
            </svg>
          </button>
          <ul v-show="citiesVisible" class="tw-absolute tw-h-0 tw-top-[50px] tw-border tw-border-solid tw-border-[#DCDCDC] tw-w-full tw-py-4 2xl:tw-py-6 tw-drop-shadow-xl tw-overflow-y-scroll"
              :class="{'tw-opacity-100 tw-h-[216px] 2xl:tw-h-[230px] tw-z-[2] tw-bg-white' : citiesVisible}" @click="setCitiesVisible(false)">
            <li class="tw-px-4 2xl:tw-px-6 hover:tw-bg-[#D0F9FF] tw-transition-all">
              <button @click="$emit('filterCity', 0)" class="tw-w-full tw-h-full tw-text-left tw-text-black tw-text-[12px] 2xl:tw-text-[1rem] tw-bg-[transparent] tw-border-none">
                All
              </button>
            </li>
            <li v-for="city in cities" :key="city.id" class="hover:tw-bg-[#D0F9FF] tw-px-4 2xl:tw-px-6 tw-transition-all">
              <button @click="$emit('filterCity', city.id)" class="tw-w-full tw-h-full tw-text-left tw-text-black tw-text-[12px] 2xl:tw-text-[1rem] tw-bg-[transparent] tw-border-none" :class="{'tw-text-dark-blue' : city.id === currentCity}">
                {{ city.city }}
              </button>
            </li>
          </ul>
        </li>
        <li id="grade-list" class="tw-relative">
          <button @click="setGradeVisible(!gradesVisible)" class="tw-border tw-border-solid tw-border-[#DCDCDC] tw-w-full tw-flex tw-justify-between tw-h-full tw-items-center tw-px-4 2xl:tw-px-6 tw-bg-white tw-cursor-pointer">
            <span class="tw-text-[#DCDCDC] tw-text-[12px] 2xl:tw-text-[1rem]">{{ currentGrade !== null ? translateGrade(grades[currentGrade].name) : 'Status' }}</span>
            <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-rotate-0 tw-transition-all" :class="{'tw-rotate-180' : gradesVisible}">
              <path d="M1 1L7 7L13 1" stroke="black" stroke-width="2"/>
            </svg>
          </button>
          <ul @click="setGradeVisible(false)"
              v-show="gradesVisible"
              class="tw-absolute tw-h-0 tw-top-[50px] tw-border tw-border-solid tw-border-[#DCDCDC] tw-w-full tw-py-4 2xl:tw-py-6 tw-drop-shadow-xl"
              :class="{'tw-h-auto tw-z-[2] tw-bg-white' : gradesVisible}">
            <li class="tw-px-4 2xl:tw-px-6 hover:tw-bg-[#D0F9FF] tw-transition-all">
              <button @click="$emit('filterGrade', null)" class="tw-w-full tw-h-full tw-text-left tw-text-black tw-text-[12px] 2xl:tw-text-[1rem] tw-bg-[transparent] tw-border-none">
                All
              </button>
            </li>
            <li v-for="(grade, index) in grades" :key="index" class="tw-px-4 2xl:tw-px-6 hover:tw-bg-[#D0F9FF] tw-transition-all">
              <button @click="$emit('filterGrade', index)" class="tw-w-full tw-h-full tw-text-left tw-text-black tw-text-[12px] 2xl:tw-text-[1rem] tw-bg-[transparent] tw-border-none" :class="{'tw-text-dark-blue' : index === currentGrade}">
                {{ translateGrade(grade.name) }}
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: "PartnersControls",
  props: {
    cities: {
      type: Array,
      required: true
    },
    currentGrade: {
      type:Number,
      default: 0
    },
    currentCity: {
      type:Number,
      default: 1
    },
    search: {
      type: String,
      required: true
    },
    grades: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      gradesVisible: false,
      citiesVisible: false
    }
  },
  mounted() {
    window.addEventListener('click',(event) => {this.closeDropdowns(event)})
  },
  beforeDestroy() {
    document.body.removeEventListener('click', (event) => {this.closeDropdowns(event)})
  },
  methods: {
    setGradeVisible(value) {
      this.citiesVisible = false
      this.gradesVisible = value
    },
    setCitiesVisible(value) {
      this.citiesVisible = value
      this.gradesVisible = false
    },
    closeDropdowns(event) {
      const el = document.querySelector('#grade-list')
      const el1 = document.querySelector('#cities-list')
      if (el !== event.target && !el.contains(event.target) && el1 !== event.target && !el1.contains(event.target)) {
        this.setGradeVisible(false)
      }
    },
    translateGrade(val) {
      switch (val) {
        case 'Платиновый':
          return 'Platinum';
        case 'Золотой':
          return 'Gold';
        case 'Серебряный':
          return 'Silver';
        case 'Бронзовый':
          return 'Bronze';
        case 'Сертифицированный':
          return 'Sertificated';
        default:
          return 'Partner';
      }
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/partners/PartnersControls.vue